import { Injectable } from '@angular/core';
import { CoolSessionStorage } from '@angular-cool/storage';
import { CsrfTokenService } from './csrf-token.service';

@Injectable({
  providedIn: 'root'
})
export class CsrfSynchronizerTokenService extends CsrfTokenService {
  private static readonly _tokenKey = 'csrftoken';

  constructor(
    private _sessionStorageService: CoolSessionStorage
  ) {
    super();
  }

  set(token: string): void {
    if (token) {
      this._sessionStorageService.setItem(CsrfSynchronizerTokenService._tokenKey, token);
    }
  }

  get needsCsrfTokenRequest(): boolean {
    return !this._readTokenValue();
  }

  _readTokenValue(): string {
    return this._sessionStorageService.getItem(CsrfSynchronizerTokenService._tokenKey);
  }
}
